import React from 'react';
import {PropTypes} from 'prop-types';

/* Atoms (custom) */
import {DateContent} from '../../atoms/DateContent/DateContent';
import {Typography} from '../../atoms/Typography/Typography';

/* Styles */
import './MessagesCard.less';

export const MessagesCard = ({
    currentState,
    lastMessageDate = '',
    location,
    messageText,
    name,
    numberOfGuests,
    stayDates,
    totalGuests,
    unreadMessages = false,
}) => {
    return (
        <div className="MessagesCard">
            <div className="MessagesCard__top">
                <Typography
                    className="MessagesCard__name"
                    content={name}
                    TagName="div"
                />
                <div className="MessagesCard__details">
                    {stayDates}
                    {totalGuests && (
                        <span className="MessagesCard__del">{'\u00B7'}</span>
                    )}
                    {totalGuests > 0 ? numberOfGuests : null}
                </div>
            </div>
            <div className="MessagesCard__bottom">
                <Typography
                    className="MessagesCard__location"
                    content={location}
                    TagName="div"
                />
                <Typography
                    className="MessagesCard__message"
                    content={messageText ? messageText : currentState}
                    TagName="div"
                />
            </div>
            <DateContent
                isMobile
                lastMessageDate={lastMessageDate}
                unreadMessages={unreadMessages}
            />
        </div>
    );
};

MessagesCard.propTypes = {
    currentState: PropTypes.string.isRequired,
    lastMessageDate: PropTypes.string,
    location: PropTypes.string.isRequired,
    messageText: PropTypes.string,
    name: PropTypes.string.isRequired,
    numberOfGuests: PropTypes.string,
    stayDates: PropTypes.string.isRequired,
    totalGuests: PropTypes.number,
    unreadMessages: PropTypes.bool,
};
